import addError from '../../../utils/error.jsx';

export function request(id, reportType, accountId) {
    return {
        type: 'REPORTS_QUERY_REQUEST',
        id,
        reportType,
        accountId
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'REPORTS_QUERY_ERROR',
        id,
        errors
    };
}

export function finish(id, accountId, data) {
    return {
        type: 'REPORTS_QUERY_FINISH',
        id,
        accountId,
        data
    };
}

export function clear(id) {
    return {
        type: 'REPORTS_QUERY_CLEAR',
        id
    };
}
